var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 17.536 17.536 5 33 5C48.464 5 61 17.536 61 33C61 48.464 48.464 61 33 61C17.536 61 5 48.464 5 33Z",
    fill: "#E47100",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0837 27.7507L41.167 23.6673M43.5003 21.334L41.167 23.6673L43.5003 21.334ZM32.2887 32.5457C32.8911 33.14 33.3699 33.8477 33.6977 34.6279C34.0255 35.4081 34.1957 36.2455 34.1985 37.0917C34.2014 37.938 34.0368 38.7764 33.7142 39.5588C33.3917 40.3412 32.9176 41.0521 32.3192 41.6505C31.7208 42.2489 31.0099 42.723 30.2275 43.0455C29.4451 43.3681 28.6067 43.5327 27.7604 43.5298C26.9141 43.527 26.0768 43.3568 25.2966 43.029C24.5164 42.7013 23.8087 42.2224 23.2143 41.62C22.0455 40.4098 21.3987 38.7889 21.4133 37.1065C21.4279 35.4241 22.1028 33.8147 23.2925 32.625C24.4822 31.4353 26.0916 30.7604 27.774 30.7458C29.4564 30.7312 31.0773 31.378 32.2875 32.5468L32.2887 32.5457ZM32.2887 32.5457L37.0837 27.7507L32.2887 32.5457ZM37.0837 27.7507L40.5837 31.2507L44.667 27.1673L41.167 23.6673L37.0837 27.7507Z",
    stroke: "#E47100",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56C20.2975 56 10 45.7025 10 33H0C0 51.2254 14.7746 66 33 66V56ZM56 33C56 45.7025 45.7025 56 33 56V66C51.2254 66 66 51.2254 66 33H56ZM33 10C45.7025 10 56 20.2975 56 33H66C66 14.7746 51.2254 0 33 0V10ZM33 0C14.7746 0 0 14.7746 0 33H10C10 20.2975 20.2975 10 33 10V0Z",
    fill: "#F2E7DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/KeyIcon.2cf4f1dc83263c32922fde600270cd09.svg";
export { ForwardRef as ReactComponent };